<template>
    <div class="table-responsive">
    <base-crud
            crudName="Itens de Checklist"
            newText="Novo Item de Checklist"
            :table="table"
            :columns="columns"
            :options="options"
            :endPoint="endPoint"
            :enableAdd="true"
            :enableEdit="true"
            :enableDelete="true"
            :enableView="false"
            :dataForm="dataForm"
        >
        </base-crud>
    </div>
</template>

<script>
import BaseCrud from "../Base/BaseCrud";

export default {
    data: function () {
        return {
            table: "checklistItemsTable",
            // pages: [],
            // url: '',
            columns: ["id", "description", "actions"],
            tableData: ["id", "description", "actions"],
            options: {
                sortable: ["id", "description", "actions"],
                filterable: ["id", "description"],
                filterByColumn: true,
                debounce: 1000,
                pagination: {chunk: 10, dropdown: false, nav: "scroll"},
                perPage: 10,
                perPageValues: [10, 25, 50, 100],
                headings: {
                    id: "ID",
                    description: "Item de Checklist",
                },
                templates: {},
                requestFunction: function (data) {
                    let requestData = {};

                    let query = this.$parent.$parent.query(data.query);
                    requestData.params = data;
                    requestData.params.query = "";
                    requestData.params.with = [];

                    return this.$http.get(this.url + "?" + query, requestData).catch(
                        function (e) {
                            this.dispatch("error", e);
                        }.bind(this)
                    );
                },
            },
            endPoint: "checklistItems/",

            dataForm: {},
        };
    },
    components: {
        BaseCrud,
    },
    methods: {
        query: function (query) {
            let columns = {
                id: "id",
                description: "description",
            };
            let filters = "";
            $.each(query, function (index, value) {
                filters += columns[index] + "=" + value + "&";
            });
            return filters;
        },
    },
};
</script>

<style scoped>
.VuePagination {
    text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/CheckListItem/Crud.vue